import { orderTransactionsNode } from '@/api/firebase'
import { firebaseObjectToArray } from '@/utils'
import { async, GET_ASYNC, ASYNC_MUTATIONS } from '@/utils/async'

const state = {
    orderTransactions: false,
    ...async()
}

const getters = {
    GET_ORDER_TRANSACTIONS: (state) => firebaseObjectToArray(state.orderTransactions),
    GET_ASYNC
}

const mutations = {
    SET_ORDER_TRANSACTIONS(state, payload) {
        state.orderTransactions = payload
    },
    CLEAR_ORDER_TRANSACTIONS(state) {
        state.orderTransactions = false
    },
    ...ASYNC_MUTATIONS()
}

const actions = {
    // =================================== Read Operations ===================================

    /**
     * FETCH_ORDER_TRANSACTIONS_BY_ORDER_ID
     *
     *     Retrieve a list of order transactions for the provided order ID.
     *
     * @param payload.id {string} - The id of the store order to retrieve.
     * @returns {Void}
     */
    FETCH_ORDER_TRANSACTIONS_BY_ORDER_ID({ commit }, payload) {
        commit('REQUEST')
        orderTransactionsNode.child(payload.id).on(
            'value',
            async function(data) {
                try {
                    const orderTransactionsData = data.val()
                    commit('SET_ORDER_TRANSACTIONS', orderTransactionsData || false)
                    commit('SUCCESS')
                } catch (err) {
                    commit('ERROR', err.message)
                }
            },
            function(err) {
                commit('ERROR', err.message)
            }
        )
    },

    // =================================== Listener Operations ===================================

    /**
     * REMOVE_ORDER_TRANSACTIONS_REFERENCE
     *
     *     Unbind a firebase connection the order transactions node for an order
     *
     * @param payload.id {string} - The id of the order.
     */
    REMOVE_ORDER_TRANSACTIONS_REFERENCE({ commit }, payload) {
        commit('CLEAR')
        orderTransactionsNode.child(payload.id).off()
    }
}

export { state, getters, mutations, actions }
